export const sourceOfEletricity = ['Diesel', 'Natural Gas', 'Grid', 'Gasoline', 'Solar'];
